import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/site/Brand";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Dr. Jain");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-cream">
      <div className="hidden lg:flex relative bg-olive-deep grain items-center justify-center p-16 overflow-hidden">
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-blush-dusty/20 blur-[90px]" />
        <div className="relative max-w-md">
          <Wordmark dark />
          <h1 className="font-serif font-light text-5xl text-cream mt-10 leading-tight">The Asmi <span className="italic text-blush-pale">Clinic Portal</span></h1>
          <p className="font-sans text-beige/80 mt-6 leading-relaxed">Manage your bio, photos, testimonials and review appointment & contact requests — all in one calm place.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm">
          <div className="lg:hidden mb-10"><Wordmark /></div>
          <h2 className="font-serif text-3xl text-olive-deep">Sign in</h2>
          <p className="font-sans text-sm text-olive-sage mt-2 mb-8">Enter your clinic credentials to continue.</p>
          <div className="space-y-4">
            <div>
              <label className="font-sans text-xs tracking-widest uppercase text-olive-sage">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
                className="mt-1.5 w-full rounded-xl border border-beige bg-white px-4 py-3 font-sans text-sm outline-none focus:ring-2 focus:ring-olive-sage transition" />
            </div>
            <div>
              <label className="font-sans text-xs tracking-widest uppercase text-olive-sage">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
                className="mt-1.5 w-full rounded-xl border border-beige bg-white px-4 py-3 font-sans text-sm outline-none focus:ring-2 focus:ring-olive-sage transition" />
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="mt-7 w-full py-3.5 rounded-full bg-olive-deep text-cream font-sans text-sm hover:bg-blush-dusty transition-colors duration-300 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
